<template>
  <v-dialog
    @keydown.esc="isOpenDialog=false"
    ref="dialog"
    max-width="800"
    :value="isOpenDialog"
    persistent
  >
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step
          :complete="step > 1"
          step="1"
        >
          Certificado de sello digital
        </v-stepper-step>

        <v-divider></v-divider>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card>
            <v-card-text>
              <v-form ref="formStep" v-model="formStep.valid">
                <v-row>
                  <v-col>
                    <div>
                      <v-icon color="warning">
                        mdi-alert-circle
                      </v-icon>
                      <b>No has cargado tu Certificado de Sello Digital, por lo que es un requisito para generar la factura de las ordenes de compras.</b>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div class="mb-3">
                      Certificado de sello digital
                    </div>
                    <div>
                      Necesitarás subir el <b>certificado</b> que es el archivo con terminación <b>".cer"</b> y la <b>llave privada</b> que es el archivo con terminación <b>".key"</b> de tu Certificado de Sello Digital.
                    </div>
                    <div>
                      Para más información <a href="https://www.sat.gob.mx/tramites/17507/envia-la-solicitud-para-tu-certificado-de-sello-digital-para-emitir-facturas-electronicas" target="_blank">haz click aquí</a>.
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      dense
                      rounded
                      outlined
                      hide-details
                      accept=".cer"
                      :rules="rules.certificate"
                      label="Certificado"
                      v-model="formStep.form.certificateFile"/>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      dense
                      rounded
                      outlined
                      hide-details
                      accept=".key"
                      :rules="rules.privateKey"
                      label="Private key"
                      v-model="formStep.form.privateKeyFile"/>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      dense
                      rounded
                      outlined
                      hide-details
                      :rules="rules.privateKeyPassword"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPassword ? 'text' : 'password'"
                      label="Password"
                      v-model="formStep.form.privateKeyPassword"
                      @click:append="showPassword = !showPassword"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                rounded
                depressed
                @click="close"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                rounded
                depressed
                @click="goUploadCSD"
              >
                Cargar datos fiscales
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>

export default {
  props: {
    isOpenDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      overlay: false,
      step: 1,
      file: null,
      formStep: {
        valid: false,
        form: {
          privateKeyPassword: '',
          certificateFile: null,
          privateKeyFile: null
        }
      },
      rules: {
        certificate: [v => !!v || 'Certificate is required'],
        privateKey: [v => !!v || 'Privatekey is required'],
        privateKeyPassword: [v => !!v || 'Privatekey password is required']
      },
      showPassword: false
    }
  },
  computed: {
    provider () {
      return this.$store.state.currentProvider.data._id
    }
  },
  methods: {
    close () {
      this.formStep.form.privateKeyPassword = ''
      this.formStep.form.certificateFile = null
      this.formStep.form.privateKeyPassword = null
      this.$emit('close')
    },
    async goUploadCSD () {
      const valid = this.$refs.formStep.validate()

      if (valid) {
        this.overlay = true
        try {
          await this.submitCSD()
          this.$toasted.show('Los datos se guardaron con éxito', { duration: 3000 })
          this.close()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    async submitCSD () {
      const form = new FormData()
      form.append('certificate', this.formStep.form.certificateFile)
      form.append('privateKey', this.formStep.form.privateKeyFile)
      form.append('privateKeyPassword', this.formStep.form.privateKeyPassword)

      await this.$api.put(`/v1/providers/${this.provider}/settings`, form)
    }
  }
}
</script>
